export const ANCHOR = {
  SALES_PERFORMANCE: 'salesPerformance',
  SALE_STAT: 'saleStat',
  BESTSELLER_RANKING: 'bestsellerRanking',
  PAGE_VIEWS_ANALYSIS: 'pageViewsAnalysis'
}

export const ANCHOR_LINK_MAP = {
  [ANCHOR.SALES_PERFORMANCE]: {
    link: ANCHOR.SALES_PERFORMANCE,
    linkTitle: '即時業績',
    sectionTitle: '即時業績',
    itemPage: true
  },
  [ANCHOR.SALE_STAT]: {
    link: ANCHOR.SALE_STAT,
    linkTitle: '訂購概況',
    sectionTitle: '訂購概況'
  },
  [ANCHOR.BESTSELLER_RANKING]: {
    link: ANCHOR.BESTSELLER_RANKING,
    linkTitle: '熱門賣場',
    sectionTitle: '熱門賣場排行',
    itemPage: true
  },
  [ANCHOR.PAGE_VIEWS_ANALYSIS]: {
    link: ANCHOR.PAGE_VIEWS_ANALYSIS,
    linkTitle: '瀏覽量分析',
    sectionTitle: '瀏覽量分析'
  }
}
